const moment = require('moment');

export function formatDateTz(date, tz) {
  return moment.tz(date, tz).format("MM/DD/YYYY  -  h:mmA");
}
